import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactChatContainer } from '../../components/ContactChatContainer/ContactChatContainer';
import { SmallFAQCallContainer } from '../../components/FAQPhoneContainer/SmallFAQCallContainer';
import { Separator } from '../../components/Separator/Separator';
import { StylesheetContext } from '../../contexts/StylesheetContext';
import styles from './PhoneSection.module.scss';

const days = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

const PhoneSection: FC = () => {
  const { stylesheet: { contact: { businessHours } } } = useContext(StylesheetContext);


  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Separator />
      <ContactChatContainer/>
      <div>
        <h3>{t('contact:businessHours')}</h3>
        <table>
          <tbody>
            {days.map((day: typeof days[number]) => (
              <tr key={day}>
                <td>{t(`days:${day}`)}</td>
                {!businessHours?.[day]
                  ? (<td>{t('shared:closed')}</td>)
                  : (<td>{businessHours[day]}</td>)
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Separator />
      <SmallFAQCallContainer renderFAQ={false} />
    </div>
  );
};

export default PhoneSection;
